import { INextAuthSessionModel } from '@/interfaces/authentication';

export const isServerSide = () => {
  return typeof window === 'undefined';
};
export const handleError = (errorCode: number) => {
  switch (errorCode) {
    case 400:
      console.log('handle 400');
      break;
    case 401:
      console.log('handle 401');
      if (!isServerSide()) {
        console.log('sign out disabled to enable retry');
        // signOut({ callbackUrl: "/" });
      }
      break;
    case 404:
      console.log('handle 404');
      break;
    case 500:
      console.log('handle 500');
      break;
    default:
      console.log('unhandled error code');
      break;
  }
};

export const getHeaderWithToken = (session?: INextAuthSessionModel | null) => {
  let serverSideHeaders = undefined;

  if (session) {
    serverSideHeaders = {
      headers: {
        Authorization: 'Bearer ' + session.accessToken,
      },
    };
  }

  return serverSideHeaders;
};
